import getEnvironment from '@zola-helpers/client/dist/es/util/environment';

const getZolaDomain = () => {
  switch (getEnvironment()) {
    case 'production':
      return 'https://www.zola.com';
    case 'staging':
      return 'https://qa.zola.com';
    case 'development':
      return 'http://127.0.0.1';
    default:
      return 'https://www.zola.com';
  }
};

export default {
  getZolaDomain,
};
